import { useEffect, useRef } from "react";
import { useStore } from "../store/store";

export function useOutsideEvent(callback, opts) {
  const ref = useRef(null);
  const { menuIsOpen } = useStore();
  
  useEffect(() => {
    function handleClickOutside(event) {
      // Don't trigger outside click if a menu is open
      if (menuIsOpen) {
        return;
      }
      
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener(
      opts?.eventType || "mousedown",
      handleClickOutside
    );
    return () => {
      document.removeEventListener(
        opts?.eventType || "mousedown",
        handleClickOutside
      );
    };
  }, [ref, menuIsOpen]);
  return ref;
}
